import {
    Button,
    Grid,
    Typography
}                      from "@mui/material";
import {
    useEffect,
    useRef,
    useState
}                      from "react";
import {
    AddContact,
    AddControle,
    AddMeasurement,
    Contact,
    ContactDetail,
    DeactivateContactCommand,
    DeactivateMeasurementCommand,
    IGStyle,
    Measurement,
    MeasurementDetail,
    UpdateContact,
    UpdateMeasurement
} from "../../constants";
import {useZINContext} from "../../context/ZinContextProvider";
import measurementsOverview from "../../pages/MeasurementsOverview";
import {submitObject}  from "../../util";

const MeasurementsBlock = () =>
{
    const {
        poolDetails,
        poolDSLFilter,
        setFormData,
        setModalVisible,
        setModalAction,
        refreshResource, setRefreshResource, setAlertVisible, setAlertText
    } = useZINContext()

    const RMRef = useRef<any>()
    const RDRef = useRef<any>()
    const [detailStatus, setDetailStatus] = useState<any>(false)
    const [detailRecord, setDetailRecord] = useState<any>("")
    useEffect(() =>
    {
        RMRef.current?.addEventListener('recordSelected', (event: any) =>
        {
            setFormData(event.detail.record)
            setDetailStatus(true)
            setDetailRecord(event.detail.recordId)
            //  setModalVisible(true)
            //  setModalAction(UpdateContact)
        })
    }, [])

    useEffect(() =>
    {
        console.log(refreshResource)
        switch (refreshResource)
        {
            case Measurement:
                setTimeout(() => RMRef.current?.refresh(), 1000)
                setTimeout(() => RDRef.current?.refresh(), 1000)
                setDetailStatus(false)
                break
            case MeasurementDetail:
                setTimeout(() => RDRef.current?.refresh(), 1000)
                setDetailStatus(false)
                break
        }
        setRefreshResource("")
    }, [refreshResource]);

    function ResetDetailStatus()
    {
        setRefreshResource(Contact)
        setDetailStatus(false)
    }

    function AddObject()
    {
        setFormData(RDRef.current?.data)

        setModalVisible(true)
        setModalAction(AddControle)
    }


    function ContactBewerken() {
        setFormData(RDRef.current?.data)

        setModalVisible(true)
        setModalAction(UpdateMeasurement)
    }

    function ContactVerwijderen() {
        submitObject({id: RDRef.current?.data.id},  poolDetails?.id, DeactivateMeasurementCommand).then(async (event: any) =>
        {
            HandleSubmit(event)
        })

        setDetailStatus(false)
        setRefreshResource(Measurement)
    }
    async function HandleSubmit(event: any)
    {
        //In case of a status that isnt 200, we most likely have received an error message.
        //So we display this as alert in the Modal
        if (event.status !== 200){
            const response = await event.json()
            setAlertVisible(true)
            setAlertText(response.messages.reduceRight((acum: any, current: any) => acum.concat(current)))
        }
    }

    return (<>
        <Grid container justifyContent="center" direction={"column"}>
            <Grid container className={"rm-container"} direction={"row"}>
                <Grid container>
                    <Typography variant="h4" marginRight={"auto"}>
                        Meetgegevens
                    </Typography>
                </Grid>

                <Grid item xs={8} container alignItems={"stretch"} className={"containerspacing"}>
                    <div style={{
                        display: detailStatus
                                 ? "contents"
                                 : "none"
                    }}>
                        <Button className={"od-button"} onClick={ResetDetailStatus}>Back</Button>
                        {/*// @ts-ignore*/}
                        <ig-resource-detail lang="nl-NL" ref={RDRef} style={IGStyle} class={"od-table-resource ig-detail-remove-id-row ig-detail-align-left"} resource-detail-id="MeasurementZINRD" resource-id={detailRecord}/>
                    </div>
                    <div style={{
                        display: detailStatus
                                 ? "none"
                                 : "contents"
                    }}> {/*// @ts-ignore*/}
                        <ig-resource-master lang="nl-NL" ref={RMRef} style={IGStyle} class={"od-table-master hide-aggregate-id-measurements"} resource-master-id="MeasurementZINRM" dsl-filter={poolDSLFilter}/>
                    </div>

                </Grid>

                <Grid container item className={"button-container"} xs={3} marginLeft={1} justifyContent={"flex-start"}>

                    <Grid container item xs={4}>
                        <Grid container direction="column" item>
                            <Button className={"od-button"} variant={"contained"}  disabled={!detailStatus}  onClick={AddObject}>Controle uitvoeren</Button>
                            {/*<Button className={"od-button"} variant={"contained"} disabled={!detailStatus} onClick={ContactBewerken}>Contact Bewerken</Button>*/}
                            {/*<Button className={"od-button"} variant={"contained"} disabled={!detailStatus} onClick={ContactVerwijderen}>Contact Verwijderen</Button>*/}
                        </Grid>
                    </Grid>

                </Grid>

            </Grid>
        </Grid>
    </>)
}

export default MeasurementsBlock